@if(isLoading()){
<app-loader message="Chargement des données..." class="margin"></app-loader>
}
@else {
<div class="container">

  <!-- Champ de recherche -->
  <mat-form-field style="width: 100%;">
    <mat-label>Recherche par nom / prénom</mat-label>
    <input matInput type="text" [value]="searchSignal()" (input)="searchSignal.set($event.target.value)">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  @if(filteredEleves().length > 0){
  <!-- Liste des élèves -->
  <mat-accordion>
    @for (eleve of filteredEleves(); track $index) {
    <mat-expansion-panel class="eleve-panel">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          @if(eleve.idAdulte !== 0){
            @if(eleve.sexe === "F"){
            <app-icon icon="woman" type="do" class="primary eleve-icon"></app-icon>
            }@else {
            <app-icon icon="man" type="do" class="primary eleve-icon"></app-icon>
            }
          }@else{
            @if(eleve.sexe === "F"){
            <app-icon icon="fille" type="do" class="primary eleve-icon"></app-icon>
            }@else {
            <app-icon icon="garcon" type="do" class="primary eleve-icon"></app-icon>
            }
          }
          <span class="eleve-nom">{{eleve.nomReferent}}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- Coordonnées -->
      <div class="fx-direction-row fx-wrap fx-gap-10">
        @if(eleve.idAdulte !== 0){
        <ng-container
          *ngTemplateOutlet="contactCardTemplate; context: { adulte: eleve.adulte1, idEnfant:eleve.idEnfant}"></ng-container>
        }
        @if(eleve.idEnfant !== 0){
          @if(eleve.adulte1.nom && eleve.adulte1.prenom){
          <ng-container
            *ngTemplateOutlet="contactCardTemplate; context: { adulte: eleve.adulte1, idEnfant:eleve.idEnfant }"></ng-container>
          }
          @if(eleve.adulte2.nom && eleve.adulte2.prenom){
          <ng-container
            *ngTemplateOutlet="contactCardTemplate; context: { adulte: eleve.adulte2, idEnfant:eleve.idEnfant }"></ng-container>
          }
        }
      </div>

      <!-- Action dossier pédagogique -->
      <div class="dossier-action">
        <button mat-stroked-button color="primary" (click)="openDossierPedagogique(eleve)">
          <mat-icon>menu_book</mat-icon>
          Dossier pédagogique
        </button>
      </div>

    </mat-expansion-panel>
    }
  </mat-accordion>
  }@else {
  <p class="section-admin-subtitle">Aucun élève.</p>
  }
</div>
}

<ng-template #contactCardTemplate let-adulte="adulte" let-idEnfant="idEnfant">
  <mat-card appearance="outlined" class="fx-flex-auto contact-card">
    <!-- Nom Prénom Responsable -->
    @if(idEnfant !== 0){
    <div class="contact-header">
      @if(adulte.sexe === "F"){
      <app-icon icon="woman" type="do" style="margin-right: 3px;"></app-icon>
      }@else {
      <app-icon icon="man" type="do" style="margin-right: 3px;"></app-icon>
      }
      <span class="contact-nom">{{adulte.nom}} {{adulte.prenom}}</span>
    </div>
    }

    <!-- Adresse -->
    <div class="contact-row">
      <mat-icon class="contact-icon">location_on</mat-icon>
      <div class="contact-text">
        @if(adulte.rue){
        <span>
          @if (adulte.numRue) { {{adulte.numRue}} }
          {{adulte.rue}}<br>
        </span>
        }
        @if(adulte.rue2){ <span>{{adulte.rue2}}<br></span> }
        @if(adulte.rue3){ <span>{{adulte.rue3}}<br></span> }
        @if(adulte.ville){
        <span>
          @if(adulte.codePostal){ {{adulte.codePostal}} }
          {{adulte.ville}}
        </span>
        }
      </div>
    </div>

    <!-- Téléphones -->
    <div class="contact-row">
      <mat-icon class="contact-icon">phone_enabled</mat-icon>
      <div class="contact-text">
        @if(adulte.telMobile){
        <span><a [href]="'tel:' + adulte.telMobile">{{ adulte.telMobile }}</a><br></span>
        }
        @if(adulte.telephone){
        <span><a [href]="'tel:' + adulte.telephone">{{ adulte.telephone }}</a></span>
        }
      </div>
    </div>

    <!-- Email -->
    @if(adulte.email){
    <div class="contact-row">
      <mat-icon class="contact-icon">mail</mat-icon>
      <div class="contact-text">
        <a [href]="'mailto:' + adulte.email">{{ adulte.email }}</a>
      </div>
    </div>
    }
  </mat-card>
</ng-template>
